<template>
  <v-container class="pa-0">
    <v-row class="ma-0">
      <v-col class="py-0 px-0" cols="3">
        <label>Ordenar por</label>
        <v-select
            v-model="orderBy"
            :items="orderByList"
            item-value="valor"
            item-text="descricao"
            :menu-props="{ bottom: true, offsetY: true }"
            flat
            solo
            dense
            outlined
            @change="updateFilter({...filterData, ...orderBy}, 1)"
        ></v-select>
      </v-col>
      <v-spacer></v-spacer>
      <v-btn
        v-if="userData.PermissaoAcoes.faturamento.includes('deletelote')"
        :disabled="!selectedLotes.length? true : false"
        outlined
        color="primary"
        depressed
        height="30px"
        small
         class="px-2 mr-2 mb-0 mt-2"
        @click="deleteLoteConfirm(selectedLotes, dadosCronograma)"
        >Excluir lote</v-btn
      >
      <v-tooltip v-else center bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            outlined
            color="rgb(151 151 151 / 58%)"
            class="px-2 mr-2 mb-0 mt-2"
            depressed
            height="30px"
            small
            v-bind="attrs"
            v-on="on"
            >Excluir lote</v-btn
          >
        </template>
        <span
          class="px-3 py-1 ma-0"
          style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;"
        >
          Você não possui permissão para executar esta ação.
        </span>
      </v-tooltip>

      <v-btn
        v-if="userData.PermissaoAcoes.faturamento.includes('addcronograma')"
        color="primary"
        depressed
        height="30px"
        small
        class="px-2 mb-0 mt-2"
        @click="$router.push({path: '/recebiveis/lotespendentes/novocronograma', query:{complementar: true}})"
        >Novo cronograma complementar</v-btn
      >
      <!-- @click="showOpen(selectedLotes, grupoSelecionado)" -->
      <v-tooltip v-else center bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            outlined
            color="rgb(151 151 151 / 58%)"
            class="px-2 ml-2"
            depressed
            height="30px"
            small
            v-bind="attrs"
            v-on="on"
            >Novo cronograma complementar</v-btn
          >
        </template>
        <span
          class="px-3 py-1 ma-0"
          style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;"
        >
          Você não possui permissão para executar esta ação.
        </span>
      </v-tooltip>
    </v-row>
    <p class="text-center pt-6 pa-2" v-show="cronogramas.length == 0">
      Não há dados disponíveis
    </p>
    <v-expansion-panels focusable v-model="cronogramaPanel" class="px-0 pt-3">
      <v-expansion-panel
        v-for="(grupo, ind) in cronogramas"
        :key="ind"
        :value="ind"
        class="mb-4 pa-0"
        @change="toggleLotesList(grupo, ind)">
        <v-expansion-panel-header class="py-0 px-3">
          <v-row class="ma-0">
            <v-col cols="2" class="pa-0">
              <div v-show="grupo.complementar" class="check-header">
                <v-tooltip bottom open-delay="100">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on"
                      ><v-icon class="pt-2 pr-1" size="14px" color="primary">fa-asterisk</v-icon></span>
                  </template>
                  <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">Cronograma complementar</span>
                </v-tooltip>
              </div>
              <div class="text-list prest px-0 py-2 ml-7">
                <v-tooltip bottom open-delay="100">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on"
                      ><b>{{ grupo.oper_nome }}</b></span>
                  </template>
                  <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">{{ grupo.oper_nome }}</span>
                </v-tooltip><br>
                <v-tooltip bottom open-delay="100">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on"
                      >{{ grupo.prest_nome }}</span
                    >
                  </template>
                  <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">{{ grupo.prest_nome }}</span>
                </v-tooltip>
                
              </div>
            </v-col>
            <v-col cols="10" class="pa-0">
              <v-row class="ma-0">
                <v-col class="text-list text-right px-0 py-3"><small>Data de faturamento:</small><br><b>{{ grupo.dt_faturamento | formatDate }}</b></v-col>
                <v-col class="text-list text-right px-0 py-3"><small>Data prev de vencimento:</small><br><b>{{ grupo.dt_prev_vencimento | formatDate }}</b></v-col>
                <v-col class="text-list text-right px-0 py-3"><small>Nº de lotes:</small><br><b>{{ grupo.qt_arq }}</b></v-col>
                <v-col class="text-list text-right px-0 py-3"><small>Valor previsto (R$):</small><br><b>{{ grupo.vl_prev_faturamento | formatPrice }}</b></v-col>
                <!-- <v-col class="text-list text-right px-0 py-3"><small v-if="grupo.login_prestador">Ident. prestador:</small><br><b>{{ grupo.login_prestador }}</b></v-col>
                <v-col class="text-list text-right px-0 py-3"><small v-if="grupo.tipo_guia_desc">Tipo de Guia:</small><br><b>{{ grupo.tipo_guia_desc }}</b></v-col> -->
                <v-col cols="4" class="text-list text-center px-0 py-3">
                  <v-tooltip bottom open-delay="100">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon 
                        class="mr-3 mt-2" 
                        color="primary" 
                        small
                        v-bind="attrs" 
                        v-on="on"
                        @click="openAddLote($event, grupo)"
                      >fas fa-upload
                      </v-icon>
                    </template>
                        <!-- @click="download($event, {doc_id: pagamento.doc_id_resultado})" -->
                    <span
                      class="px-3 py-1 ma-0"
                      style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
                      >Upload de lote pendente</span
                    >
                  </v-tooltip>
                  <v-tooltip bottom open-delay="100" v-if="userData.UsuarioTradimus">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon 
                        v-if="dadosCronograma.id && dadosCronograma.id == grupo.id && userData.PermissaoAcoes.faturamento.includes('updateprotocolo') && grupo.qt_arq_novo"
                        class="mr-3 mt-2" 
                        color="primary" 
                        small
                        v-bind="attrs" 
                        v-on="on"
                        @click="openProtocoloEmMassa($event, grupo)"
                      >fa-barcode
                      </v-icon>
                      <v-icon 
                        v-else 
                        class="mr-3 mt-2" 
                        color="grey" 
                        small 
                        v-bind="attrs" 
                        v-on="on"
                        @click="($event) => $event.stopPropagation()"
                      >fa-barcode</v-icon>
                    </template>
                    <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">
                        Protocolo em massa
                    </span>
                  </v-tooltip>
                    <v-tooltip bottom open-delay="100">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon 
                        class="mr-3 mt-2" 
                        color="primary" 
                        small
                        v-bind="attrs" 
                        v-on="on"
                        @click="notaFiscal($event, grupo)"
                      >fas fa-file-invoice-dollar
                      </v-icon>
                    </template>
                        <!-- @click="download($event, {doc_id: pagamento.doc_id_dac})" -->
                    <span class="px-3 py-1 ma-0"
                      style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
                      >Notas fiscais</span>
                  </v-tooltip>
                  <v-tooltip bottom open-delay="100">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon 
                        v-if="userData.PermissaoAcoes.faturamento.includes('updatecronograma') && grupo.status != 'F'"
                        class="mr-3 mt-2" 
                        color="primary" 
                        small
                        v-bind="attrs" 
                        v-on="on"
                        @click="editCronograma($event, grupo.id)" 
                      >fa-pencil-alt
                      </v-icon>
                      <v-icon 
                        v-else 
                        class="mr-3 mt-2" 
                        color="grey" 
                        small 
                        v-bind="attrs" 
                        v-on="on"
                        @click="($event) => $event.stopPropagation()"
                      >fa-pencil-alt</v-icon>
                    </template>
                    <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">
                      <span v-if="userData.PermissaoAcoes.faturamento.includes('updatecronograma') && grupo.status != 'F'">Editar Cronograma</span>
                      <span v-if="!userData.PermissaoAcoes.faturamento.includes('updatecronograma')">Você não possui permissão para executar esta ação.</span> 
                      <span v-if="userData.PermissaoAcoes.faturamento.includes('updatecronograma') && grupo.status == 'F'">Cronograma fechado não pode ser editado.</span> 
                    </span>
                  </v-tooltip>
                   <v-tooltip bottom open-delay="100" v-if="grupo.qt_arq==0">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon 
                        class="mr-3 mt-2" 
                        color="primary" 
                        small
                        v-bind="attrs" 
                        v-on="on"
                        @click="deleteCronograma($event, grupo)" 
                      >fa-trash-alt
                      </v-icon>
                    </template>
                    <span class="px-3 py-1 ma-0"
                      style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
                      >Excluir Cronograma</span>
                  </v-tooltip>
                 <v-tooltip bottom open-delay="100" v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon 
                        class="mr-3 mt-2" 
                        color="grey" 
                        small
                        v-bind="attrs" 
                        v-on="on"
                        @click="($event)=>$event.stopPropagation()"
                      >fa-trash-alt
                      </v-icon>
                    </template>
                    <span class="px-3 py-1 ma-0"
                      style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
                      >Não é possível excluir cronograma que possui lotes.</span>
                  </v-tooltip>
                  <v-btn
                    v-if="userData.PermissaoAcoes.faturamento.includes('associarlotesemcronograma') && grupo.qt_arq_novo"
                    :disabled="!grupo.qt_arq_novo? true : false"
                    color="primary"
                    depressed
                    x-small
                    class="px-2 mt-2"
                    @click="$event.stopPropagation(); concluirCronograma(grupo)"
                    >Concluir</v-btn>
                    <v-tooltip bottom open-delay="50" v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn 
                        class="px-2 mt-2 grey--text text--lighten-2"
                        color="grey" 
                        depressed
                        x-small
                        v-bind="attrs" 
                        v-on="on"
                        @click="$event.stopPropagation()"
                      >Concluir
                      </v-btn>
                    </template>
                    <span class="px-3 py-1 ma-0"
                      style="border: solid 1px #999; border-radius: 5px; background-color: #FFF"
                      >Este cronograma não possui lotes novos.</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- {{ind}} -->
        </v-expansion-panel-header>
        <v-expansion-panel-content>
           <v-alert dense  outlined type="error" class="text-left mb-0" ><b>Lotes complementares não serão enviados para a operadora.</b></v-alert>
          <v-data-table
            :headers="headers"
            show-select
            v-model="selectedLotes"
            :items="listFilter"
            :items-per-page="itemsPerPage"
            :page.sync="page"
            @page-count="pageCount = parseInt($event, 10)"
            class="lotesListTable"
            hide-default-footer
            dense
          >
            <template v-slot:item.arq_nome="{ item }">
              
              <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }" >
                    <span v-bind="attrs" v-on="on" class="pa-0">
                      <span v-if="item.is_deleted" class="new-lote">novo</span>
                      <span>{{ item.arq_nome }}</span>
                    </span>
                  </template>
                  <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF">{{ item.arq_nome }}</span>
                </v-tooltip>
            </template>
            <template v-slot:item.upload_dt="{ item }">
              {{ item.upload_dt | formatDate }}
            </template>
            <template v-slot:item.etapa="{ item }">
              <b v-if="item.etapa == 10">Em validação</b>
              <b style="color:#45bf96" v-if="item.etapa >= 20 && (item.proc_trd_tem_erro == 0)">Validado</b>
              <b style="color:#da364a" v-if="item.etapa >= 20 && (item.proc_trd_tem_erro == 1)">Erro na validação</b>
              <v-btn
                  v-if="item.etapa >= 20 && (item.proc_trd_tem_erro == 1) && !bloqueia_protocolo"
                  @click="infoItem(item, 'erro')" 
                  class="py-0 px-0" 
                  color="#D0021B"
                  small 
                  icon>
                <v-icon class="pa-0" small>far fa-eye</v-icon>
              </v-btn>
              <v-tooltip left v-else-if="bloqueia_protocolo">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color=""
                    x-small
                    icon
                    v-bind="attrs"
                    v-on="on"
                  ><v-icon small style="font-size:13px;">far fa-eye</v-icon>
                  </v-btn>
                </template>
                <span class="pa-5">Não é possível ignorar nem corrigir este tipo de erro.</span>
              </v-tooltip>
            </template>
            <template v-slot:item.arq_vl_calculado="{ item }">
              {{ item.arq_vl_calculado | formatPrice }}
            </template>
            <template v-slot:header.etapa="{ header }">
              {{ header.text }}
              <v-menu
                offset-y
                max-width="25%"
                :close-on-content-click="closeOnContentClick"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="px-0 py-0" dark v-bind="attrs" v-on="on" icon>
                    <v-icon
                      class="px-1 pt-0"
                      color="primary"
                      size="14px"
                      @click="openInfo = true"
                      >fa-filter</v-icon
                    >
                  </v-btn>
                </template>
                <v-card class="px-3 pt-0 pb-0" outlined flat solo>
                  <v-row v-show="openInfo">
                    <v-col
                      class="text-left px-3 pb-3 pt-2"
                      cols="12"
                      style="color: #035A27"
                    >
                      <v-icon class="px-0 pt-0" color="#035A27"
                        >fa-angle-up</v-icon
                      >
                      ESTADOS
                    </v-col>
                    <v-col class="text-left px-2 py-0" cols="10">
                      <v-checkbox
                        multiple
                        class="mt-0 mb-0 py-0"
                        v-model="selectedFilter"
                        :value="1"
                        label="Validados"
                      ></v-checkbox>
                    </v-col>
                    <v-col class="text-right px-2 py-0" cols="2">
                      <div class="porcentagem">
                        {{
                          listLotes.filter((lote) => lote.etapa >= 20 && (lote.proc_trd_tem_erro == 0 && lote.env_op_tem_erro == 0))
                            .length
                        }}
                      </div>
                    </v-col>
                    <v-col class="text-left px-2 py-0" cols="10">
                      <v-checkbox
                        multiple
                        class="mt-0 mb-0 py-0"
                        v-model="selectedFilter"
                        :value="3"
                        label="Em validação"
                      ></v-checkbox>
                    </v-col>
                    <v-col class="text-right px-2 py-0" cols="2">
                      <div class="porcentagem">
                        {{
                          listLotes.filter(
                            (lote) => lote.etapa == 10 && lote.proc_trd_tem_erro == 0
                          ).length
                        }}
                      </div>
                    </v-col>
                    <v-col class="text-left px-2 py-0" cols="10">
                      <v-checkbox
                        multiple
                        class="mt-0 mb-0 py-0"
                        v-model="selectedFilter"
                        :value="6"
                        label="Erro na validação"
                      ></v-checkbox>
                    </v-col>
                    <v-col class="text-right px-2 py-0" cols="2">
                      <div class="porcentagem">
                        {{
                          listLotes.filter(
                            (lote) => lote.etapa >= 10 && (lote.proc_trd_tem_erro == 1 || lote.env_op_tem_erro == 1)
                          ).length
                        }}
                      </div>
                    </v-col>
                    <v-col class="text-right px-2 pb-3 pt-0" cols="12">
                      <v-btn
                        max-width="100%"
                        height="40px"
                        color="primary"
                        depressed
                        class="px-3"
                        @click="
                          [getListLotes({cronograma_id: grupo.id}, null, grupo),
                            showSelectedFilter(selectedFilter)]"
                        >Filtrar</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card>
              </v-menu>
            </template>
            <template v-slot:item.env_op_protocolo="{ item }">
            <div class="d-flex justify-space-between">
              <v-col class="text-center py-0 px-0 pa-0 mt-2">{{ item.env_op_protocolo }}</v-col>
              <v-btn 
                class="mt-0 mb-0 ml-1" 
                color="primary"
                small 
                icon 
                v-if="item.etapa >= 20 && (!item.proc_trd_tem_erro || (parameters && parameters.FAT_ACEITA_XML_INVALIDO)) && item.is_deleted && !bloqueia_protocolo">
                <v-icon v-if="userData.PermissaoAcoes.faturamento.includes('updateprotocolo')" @click="getProtocolo(item, grupo)" small>fa-pencil-alt</v-icon>
                <v-icon v-else @click="userInfo()" small>fa-pencil-alt</v-icon>
              </v-btn> 
              <v-tooltip left v-else-if="bloqueia_protocolo">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color=""
                    x-small
                    icon
                    v-bind="attrs"
                    v-on="on"
                  ><v-icon small style="font-size:13px;">fa-circle</v-icon>
                  </v-btn>
                </template>
                <span class="pa-5">Não é possível incluir o protocolo. Exclua o arquivo.</span>
              </v-tooltip>
            </div>
            <v-col v-if="item.env_op_protocolo" class="text-center pa-0">
              {{ item.env_op_dt_protocolo | formatDate }}
            </v-col>
          </template>
          </v-data-table>
          <div
            class="text-left pa-0 py-4 col-md-12"
            v-show="showFilter && selectedEstadoFilter.length != 0"
          >
            <b>Filtro:</b>
            <v-chip
              v-for="etapa in selectedEstadoFilter"
              :key="etapa"
              close
              label
              pill
              @click:close="[
                  removerFiltro(etapa),
                  getListLotes({cronograma_id: grupo.id}, null, grupoSelecionado)]"
              >{{
                etapa == 1
                  ? 'Validados'
                  : etapa == 3
                  ? 'Em validação'
                  : 'Erro na validação'
              }}</v-chip
            >
          </div>
          <div class="text-center mt-2 py-0 col-md-12">
            <small>* Os lotes complementares só seráo incluídos no cronograma após a conclusão da complementação.</small><br>
            <v-pagination
              class="no-box-shadow"
              v-model="page"
              :length="pageCount"
            ></v-pagination>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
      <v-divider></v-divider>
    <v-row>
      <div class="text-center mt-2 py-0 col-md-12">
      <v-pagination
        class="no-box-shadow"
        v-model="pageCrono"
        :length="paginationCrono.total_pages"
        @input="updateFilter(filterData, pageCrono)"
      ></v-pagination>
      </div>
    </v-row>
    <CronogramaModalAddLote
      :dialog="showAddLote"
      :close="() => (showAddLote=false, getListLotes({cronograma_id: dadosCronograma.id}, null, grupoSelecionado))"
      :grupoEconomico='grupoEconomico'
      :userData='userData'
      :dadosCronograma='dadosCronograma'
      :lotesPendentes="true"
      :multioperadoras_list="multioperadoras_list"
    />
    <ProtocoloDlg
      :dialog="showProtocolo"
      :showClose="()=>showProtocolo=false"
      :items="protocolo"
      :sendForm="(formData, acao) => saveProtocolo(formData, acao)"
      :isLoteComplementar="true"
      :complementar="complementar"
    />
    <ProtocoloEmMassaDlg
      :dialog="protocoloEmMassa"
      :close="() => {this.protocoloEmMassa = false; getListLotes({cronograma_id: dadosCronograma.id}, null, dadosCronograma.id)}"
      :data="dadosCronograma"
      :lotesIds="lotesIdsProtocolo"
      :complementar="true"
    />
    <LotesErrosDlg
      :dialog="showInfo"
      :showClose="() => {showInfo = false; dadosDoLote = {}}"
      :dadosDoLote="dadosLote"
      :error="itemError"
      :critica="itemCritica"
      :parameter="false"
      :showValue="showValue"
      :errorType="errorType"
      :userData="userData"
    />
  </v-container>
</template>

<script>
  import moment from 'moment';
  moment.locale('pt-BR');
  import CronogramaModalAddLote from '@/components/faturamento/dados_cronograma/CronogramaModalAddLote'
  import LotesErrosDlg from '@/components/faturamento/lotes_sem_cronograma/LotesErrosDlg'
  import ProtocoloDlg from '@/components/faturamento/dados_cronograma/ProtocoloDlg'
  import ProtocoloEmMassaDlg from '@/components/faturamento/dados_cronograma/ProtocoloEmMassaDlg'

  export default {
    components: {
      CronogramaModalAddLote,
      ProtocoloDlg,
      ProtocoloEmMassaDlg,
      LotesErrosDlg
    },
    data() {
      return {
        grupoEconomico: this.$store.state.permissions.grupoEconomico,
        showAddLote: false,
        multioperadoras_list: [],
        showProtocolo: false,
        protocolo: {},
        dadosLote: {},
        page:1,
        pageCrono: 1,
        pageCount: 1,
        itemsPerPage: 10,
        cronogramaPanel: null,
        dadosCronograma: {},
        openedPanel: null,
        valueSelect: null,
        positions: null,
        newPosition: null,
        grupoSelecionado: null,
        selectedLotes: [],
        selectedFilter: [],
        selectedEstadoFilter: [],
        showFilter: false,
        //dados de erro
        showInfo: false,
        itemError: null,
        itemCritica: null,
        errorType: null,
        showValue: null,
        //fim dados de erro
        openInfo: false,
        closeOnContentClick: false,
        headers: [
          { text: 'Lotes complementares*', value: 'arq_nome', sortable: false },
          { text: 'Import.', value: 'upload_dt', sortable: false },
          { text: 'Tipo guia', value: 'tipo_guia_descricao', sortable: false },
          { text: 'Nº lote', value: 'arq_numero_lote', align: 'center', sortable: false },
          {
            text: 'Valor (R$)', value: 'arq_vl_calculado',
            align: 'right',
            sortable: false,
          },
          {
            text: 'Qtd. guia',
            value: 'arq_qtd_guias',
            align: 'center',
            sortable: false,
          },
          { text: 'Estado', value: 'etapa', class: 'pl-4 pr-0', sortable: false},
          { text: 'Protocolo', value: 'env_op_protocolo', class: 'pl-4 pr-0', sortable: false},
        ],
        complementar: false,
        listFilter: [],
        // parameter: false
        orderBy: null,
        orderByList:[
          {descricao: "Selecione", valor: null},
          {descricao: "Maiores quatidades de lotes", valor:{sort: 'qt_arq', order:'Desc'}},
          {descricao: "Menores quatidades de lotes", valor:{sort: 'qt_arq', order:'Asc'}},
          {descricao: "Maiores valores previstos", valor:{sort: 'vl_prev_faturamento', order:'Desc'}},
          {descricao: "Menores valores previstos", valor:{sort: 'vl_prev_faturamento', order:'Asc'}}
        ],
        protocoloEmMassa: false,
        lotesIdsProtocolo: []
      };
    },
    methods: {
    infoItem(obj, type) {
      this.showValue = type
      this.dadosLote = obj
      this.getError(obj.id).then((resp)=> this.showInfo = resp)
    },
    async getError(id) {
      let _this = this
      let obj = {
        query: [{ 
          Modulo: "Faturamento",
          Acao: "geterroslote",
          Payload: {
            grupo_economico: this.$store.state.permissions.grupo_economico,
            lote_id: id,
          }
        }],
      }
      let hasErro = await this.$store.dispatch("request/doRequest", obj).then((response) => {
          if (!response || response.isAxiosError || !response.sucesso) {
            this.$store.commit("hideLoader");
            return false;
          }
          
          let json = JSON.parse(response.lote_erros)
          if (response.lote_erros != null) {
            _this.itemError = json.Erros? json.Erros : json.Erro ? json.Erro : null
            _this.itemCritica = json.criticas? json.criticas : null
            _this.errorType = _this.itemError != null? 1 : 2
            return true
          } else {
            _this.itemError = null
            _this.itemCritica = null
            _this.errorType = null
            return false
          }
          
        })
        return hasErro
      },
      modalVideo(){
      let paramModal = {
          codigo: "754272580",
          title: "Como excluir lotes",
        }
        this.$store.commit('tutorial/abreVideo', paramModal);
      },
      openAddLote(e, cronograma){
        e.stopPropagation()
        console.log('openAddLote')
        this.dadosCronograma = cronograma
        this.dadosCronograma.grupo_economico = this.grupoEconomico
        if(this.dadosCronograma.config && this.dadosCronograma.config.CG_MULTIOPERADORAS &&  this.dadosCronograma.config.CG_MULTIOPERADORAS_ANS)
        {
          let obj = {
            query: [{ 
              Modulo: "Portal",
              Acao: "getoperadorasansregistros",
              Payload: {
                grupo_economico: this.grupoEconomico,
                operadora_ans_id: this.dadosCronograma.operadora_ans_id,
                prestador_id: this.dadosCronograma.prestador_id
              }
            }],
          }
          this.$store.dispatch("request/doRequest", obj).then(response => {
            this.multioperadoras_list = response.dados;
            this.showAddLote = true;
          })
        } else {
          this.multioperadoras_list = [];
          this.showAddLote = true;
        }
      },
      openProtocoloEmMassa(e, cronograma) {
        e.stopPropagation()
        cronograma.grupo_economico = this.grupoEconomico;
        this.dadosCronograma = cronograma
        let validation = this.listLotes.filter(el => el.etapa > 10).length > 0
      this.lotesIdsProtocolo = this.listLotes.filter(el => el.etapa > 10).map(el => el.id)
      if (!validation) {
        this.protocoloEmMassa = false
        let paramModal = {
          type: "info",
          title: "Não há lotes a serem editados!",
          message: "Lotes em validação <br> não estão aptos a receberem protocolo.",
          btConfirm: { name: "Ok", show: true }
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      } else {
        let outUse = this.listLotes.filter(el => el.protocolo_editing_user != null && el.protocolo_editing_user != this.userData.UserName)
        this.userProtocoloAlocado = outUse.length ?outUse[0].protocolo_editing_user : null
        let paramModal = {
          type: "info",
          title: "Há lotes selecionados que não podem ser editados!",
          message: "Lotes abertos com outro usuário ou em validação <br> serão ignorados na seleção de edição em massa de protocolo.<br> Deseja prosseguir?",
          callback: () => {this.protocoloEmMassa = true},
          btConfirm: { name: "sim", show: true },
          btCancel: { name: "não", show: true }
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      }
    },
      getProtocolo(item, grupo) {
        this.complementar = grupo.complementar
        this.loteData = item
      let obj = {
        query: [{ 
          Modulo: "Faturamento",
          Acao: "getprotocolo",
          Payload: {
            grupo_economico: this.grupoEconomico,
            lote_id: item.id
          }
        }],
      }
      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.protocolo = response.protocolo
        this.dadosLote = item
        this.showProtocolo = true
      })
    },
    saveProtocolo(formData, acao) {
      let obj = {
        query: [{ 
          Modulo: "Faturamento",
          Acao: acao,
          Payload: {
            grupo_economico: this.grupoEconomico,
            prestador_id: this.dadosCronograma.prestador_id,
            operadora_ans_id: this.dadosCronograma.operadora_ans_id,
            lote_id: this.loteData.id,
            ...formData
          }
        }],
      }
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            this.getListLotes({cronograma_id: this.dadosCronograma.id}, null, this.dadosCronograma)
          },
          btConfirm: { name: "Ok", show: true },
          btCancel: { name: 'Cancelar', show: false }
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
      removerFiltro(estado) {
        var index = this.selectedFilter.indexOf(estado);
        this.selectedFilter.splice(index, 1);
      },
      showSelectedFilter(filter) {
        this.showFilter = true;
        this.selectedEstadoFilter = filter;
        this.openInfo = false;
      },
      position(ind, item) {
        this.valueSelect = ind;
        this.grupoSelecionado = item;
        if (ind != this.positions) {
          this.selectedLotes = [];
        }
      },
      selecionaTodosDoGrupo(selection, ind, grupo) {
        if (selection.value) {
          this.positions = ind;
          this.grupoSelecionado = grupo;
          this.selectedLotes = selection.items;
        } else {
          this.selectedLotes = [];
          this.positions = null;
          this.grupoSelecionado = null;
        }
      },
      selecaoUnica(selection, ind, grupo) {
        if (selection.value) {
          if (this.positions != ind) {
            this.selectedLotes = [];
            this.selectedLotes.push(selection.item);
            this.positions = ind;
            this.grupoSelecionado = grupo;
          }
        } else {
          if (this.selectedLotes.length == 0) {
            this.positions = null;
            this.grupoSelecionado = null;
          }
        }
      },
      notaFiscal(e, grupo) {
        e.stopPropagation()
        delete grupo.complementar
        let paramModal = { dados: {complementar: true, ...grupo} }
        this.$store.commit("notasFiscais/showNotas", paramModal);
      },
      deleteCronograma(e, grupo) {
        e.stopPropagation()
        let paramModal = {
          type: "error",
          title: "Exluir cronograma?",
          message: 'Ao excluir, este cronograma não estará mais disponível.<br>Essa alteração <b>não</b> poderá ser desfeita.',
          callback: () => this.deleteCronogramaConfirm(grupo),
          btConfirm: { name: "Excluir", show: true, color: "error" },
          btCancel: { name: "Não", show: true },
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      },
      // concluirCronograma(e, grupo) {
      //   e.stopPropagation()
      //   // this.getListLotes({cronograma_id: grupo.id}, grupo)
      //   this.concluirCronograma(grupo)
      // },
      userInfo() {
        let paramModal = {
          type: "error",
          title: "Atenção!",
          message: "Você não possui permissão para executar esta ação. <br/> Contacte o seu gestor.",
          callback: null,
          btConfirm: { name: "Fechar", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      },
      editCronograma(e, id) {
        e.stopPropagation()
        let url  = {path: '/recebiveis/lotespendentes/editarcronograma/'+id, query:{complementar: true}}
        // let url = '/recebiveis/lotespendentes/editarcronograma/'+id
        this.$router.push(url)
      },
      toggleLotesList(grupo, ind){
        if(this.cronogramaPanel == ind) {
          this.listFilter = []
          this.dadosCronograma={}
          this.selectedLotes = []
        } else {
          this.selectedLotes = []
          this.dadosCronograma=grupo; 
          this.getListLotes({cronograma_id: grupo.id}, null, grupo ); 
        }
      }
    },
    props: {
      showOpen: Function,
      cronogramas: Array,
      listLotes: Array,
      paginationCrono: Object,
      paginationLotes:Object,
      parameters: Object,
      filterData: Object,
      getListLotes: Function,
      deleteLoteConfirm: Function,
      deleteCronogramaConfirm: Function,
      updateFilter: Function,
      userData: Object,
      concluirCronograma: Function
    },
    watch: {
      cronogramas: {
        deep: true,
        handler() {
          this.selectedLotes = [];
          this.cronogramaPanel = null;
          this.positions = null;
        },
      },
      listLotes(list) {
        let newList = []
        newList = list.reduce((arr, item) => {
          let valido = null
          let emValidacao = null
          let erroValidacao = null
          if (this.selectedEstadoFilter.filter(el => el == 1).length > 0) {
            valido = item.etapa >= 20 && (item.proc_trd_tem_erro == 0 && item.env_op_tem_erro == 0)
          } 
          if (this.selectedEstadoFilter.filter(el => el == 3).length > 0) {
            emValidacao = item.etapa == 10 && item.proc_trd_tem_erro == 0 
          } 
          if (this.selectedEstadoFilter.filter(el => el == 6).length > 0) {
            erroValidacao = item.etapa >= 10 && (item.proc_trd_tem_erro == 1 || item.env_op_tem_erro == 1) 
          } 
          if (this.selectedEstadoFilter.length == 0) {
            valido = item
            emValidacao = item
            erroValidacao = item
          }
          if (valido || emValidacao || erroValidacao) {arr.push(item)}
          return arr
        }, [])
        // this.parameter = this.dadosCronograma.config? this.dadosCronograma.config.FAT_ENVIO_OPERADORA : false
        this.listFilter = newList
      }
    },
    filters: {
      formatDate(date) {
        return moment(date).format('L');
      },
      formatNullValue(val) {
        return val ? val : '-';
      },
      formatPrice(value) {
        let val = (value / 1).toFixed(2).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      },
    },
  };
</script>

<style lang="scss">
  .no-box-shadow,
  .no-box-shadow * {
    box-shadow: 0 0 0 0 !important;
  }
  button.v-expansion-panel-header {
    background-color: #eff3f8;
    border-radius: 2px;
    padding: 0;
  }
  .v-expansion-panel::before {
    box-shadow: none;
  }
  .v-expansion-panel-content {
    display: flex;
    margin: 0 -24px;
  }
  .theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: #ffffff;
  }
  .text-list {
    font-size: 13px;
  }
  .text-list.space {
    margin-right: 3px;
  }
  .text-list.prest {
    // width: 120px;
    line-height: 1.4;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }
  .check-header {
    position: absolute;
    margin-top: 1px;
    margin-left: 5px;
  }
  .check-content {
    position: absolute;
    margin-top: -16px;
  }
  .check-border {
    border: none;
  }
  .porcentagem {
    border-radius: 8px;
    padding: 0 0 0 0;
    text-align: center;
    width: 100%;
    border: 1.5px solid #9e9e9e;
    font-size: 12px;
    color: #9e9e9e;
  }
  .v-expansion-panel-header .row {
    align-items: center;
  }
  .v-chip {
    border-bottom-style: solid;
    left: 0.8rem;
  }
  .v-chip:nth-child(3) {
    margin-left: 0.3rem;
  }
  .v-chip:last-child {
    margin-left: 0.3rem;
  }
  #check-color {
    .v-icon.v-icon {
      align-items: center;
      display: inline-flex;
      font-feature-settings: 'liga';
      font-size: 24px;
      justify-content: center;
      letter-spacing: normal;
      line-height: 1;
      position: relative;
      text-indent: 0;
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
      vertical-align: middle;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      color: #118aca;
    }
  }
  .theme--light.v-data-table.lotesListTable   .v-icon.v-icon {
    font-size: 16px !important;
}
i.v-icon.notranslate.text-icon.material-icons.theme--light.red--text {
  font-size: 12px;
  font-weight: 600;
  font-family: "Catamaran";
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff;
}
.no-box-shadow, .no-box-shadow *{
  box-shadow: 0 0 0 0!important;
}
.theme--light.v-data-table.lotesListTable > .v-data-table__wrapper > table > thead > tr > th,
.theme--light.v-data-table.lotesListTable > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 5px
}
.theme--light.v-data-table.lotesListTable > .v-data-table__wrapper > table > thead > tr > th:nth-child(2),
.theme--light.v-data-table.lotesListTable > .v-data-table__wrapper > table > tbody > tr > td:nth-child(2) {
    max-width: 150px;
    text-overflow: ellipsis;
    overflow: hidden;
}
.theme--light.v-data-table.lotesListTable > .v-data-table__wrapper > table > thead > tr > th:nth-last-child(2),
.theme--light.v-data-table.lotesListTable > .v-data-table__wrapper > table > tbody > tr > td:nth-last-child(2){
    max-width: 80px;
}
.new-lote {
  background-color: #cfd403;
  border-radius: 6px;
  padding: 0px 4px;
  font-size: 8px;
  font-family: sans-serif;
  font-weight: 700;
  margin-right: 3px;
  position: relative;
  bottom: 4px;
}
</style>
